export default __webpack_public_path__ + "7cdb52d75cd816a74e9ddc1735abd5ff.woff2";